// Model-written plan fields (assumptions, warnings, constraints) are
// documented as strings, but the validator stores whatever list the model
// returned. CLAUDE.md records an assessment report that crashed on an object
// rendered as text, so every free-text field the plan UI shows goes through
// here: a string is shown, a string field inside an object is shown, and
// anything else is dropped. The page never shows "[object Object]", a raw
// JSON blob, or throws while rendering.

const TEXT_KEYS = ['text', 'summary', 'label', 'description', 'title', 'message'];

export function displayText(value) {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    for (const key of TEXT_KEYS) {
      if (typeof value[key] === 'string' && value[key].trim()) return value[key].trim();
    }
  }
  return '';
}

export function displayTextList(values) {
  if (!Array.isArray(values)) return [];
  return values.map(displayText).filter(Boolean);
}
